import { PREMATCH_GAME_TYPE_FOR_SWARM } from 'utils/constants/sportsbook/data-fields';
import { EAdvancedEventsLayouts } from 'interfaces/sportsbook';

export const getGameWhereByLayoutType = ({
  layoutType
}: {
  layoutType: EAdvancedEventsLayouts;
}) => {
  const gameWhereObjByType = {
    live: { type: 1 },
    upcoming: PREMATCH_GAME_TYPE_FOR_SWARM,
    popular: {
      type: { '@in': [0, 1, 2] },
      promoted: true
    }
  };

  return gameWhereObjByType[layoutType];
};
